import { useMutation } from "@tanstack/react-query";
import { useChatApiClient } from "@trinity/chat-components/containers/Chat";


export function useCancelSegmentation({ queryIdentifier }: { queryIdentifier: string }) {
  const apiClient = useChatApiClient();

  const tagSelectionMutation = useMutation({
    mutationFn: async () => {
      const response = await apiClient.authenticatedClient.post('/chat/segmentation/cancel', {
        queryIdentifier,
      });
      return response.data;
    },
  });

  return tagSelectionMutation;
}